import { useGetPresentationCapabilitiesQuery } from 'src/services/presentations/presentations.service';

/** What this installation can do (JT1-1887). Word features stay off until the answer says otherwise. */
export function usePresentationCapabilities() {
  const { currentData } = useGetPresentationCapabilitiesQuery();
  return { wordConversion: !!currentData?.word_conversion };
}
